import axiosInstance from "../../../utils/axios";
import { ROLE } from "../../../utils/Constants";
const options = {role: ROLE.SUPER_ADMIN};

const path = "admin/pending-appointment";


export const List = async (values) => {
  return await axiosInstance(options).post(`${path}/list`, values);
};

export const Details = async (values) => {
  return await axiosInstance(options).post(`${path}/details`, values);
};

